<template>
    <b-container>
      <h1>Attiva il tuo pacchetto</h1>
    </b-container>
</template>

<script>
  export default {
    name: "attiva"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Attiva.vue